import API from './API.js'

export default class ExamsQuestions extends API {
  constructor() {
    super('examsQuestions')
  }
}
